import { MOUSE_EVENT_TYPES, TOUCH_EVENT_TYPES, } from './hooks.constants';
export const getEventInputType = (event) => {
    if (MOUSE_EVENT_TYPES.includes(event.type)) {
        return 'mouse';
    }
    if (TOUCH_EVENT_TYPES.includes(event.type)) {
        return 'touch';
    }
    return 'other';
};
